module.exports = __webpack_public_path__ + "static/media/nav-icon-bars-active.a528897f.svg";